import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=d020289a&scoped=true&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"
import style0 from "./Tab.vue?vue&type=style&index=0&id=d020289a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d020289a",
  null
  
)

export default component.exports